import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MarkdownModule } from 'ngx-markdown';

import { RiesHubUiComponentsModule } from '@digital-platform/ries-hub-ui/components';
import { SharedServicesModule } from '@digital-platform/shared/services';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { WasteProfilesServicesModule } from '@digital-platform/waste-profiles/services';
import { RiesHubUiShellComponent } from './ries-hub-ui-shell/ries-hub-ui-shell.component';
import { RiesHubUiShellRoutingModule } from './ries-hub-ui-shell-routing.module';
// import 'https://aura-app-bar-ts-us109494-aura-app-bar.aura-nonprod.awsext.repsrv.com/aura-app-bar.js';

@NgModule({
  imports: [
    CommonModule,
    MarkdownModule.forRoot(),
    SharedUiMaterialModule,
    RiesHubUiComponentsModule,
    FlexLayoutModule,
    RiesHubUiShellRoutingModule,
    SharedServicesModule,
    WasteProfilesServicesModule,
  ],
  declarations: [RiesHubUiShellComponent],
})
export class RiesHubUiShellModule {}
